module.exports = __webpack_public_path__ + "static/media/r360.db264831.jpg";